import { createGenericSlice } from './generic.slice'
import { RootState } from '@store/store'

// Define the Voice type (you should have this defined elsewhere in your project)
export interface VoiceModel {
  id: string
  name: string
  value: string
  defaultSpeed: string
  voiceGender: string
}

// Create the generic slice for the Voice entity
const {
  slice: voicesSlice,
  thunks: voiceThunks,
  adapter: voicesAdapter,
} = createGenericSlice<VoiceModel>(
  'Voice',
  'voice',
  {} // You can define extra initial state here if needed
)

export const {
  selectAll: selectAllVoices,
  // ... other selectors
} = voicesAdapter.getSelectors<RootState>((state: RootState) => state.voices)

export const { fetchAll: fetchAllVoices } = voiceThunks

export default voicesSlice.reducer
